module.exports = __webpack_public_path__ + "img/x4.a995d94e.jpg";